import { render, staticRenderFns } from "./package.vue?vue&type=template&id=ee9e3d44"
import script from "./package.vue?vue&type=script&lang=js"
export * from "./package.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports